'use client';

import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { useScrollObserver } from '../../hooks/useScrollObserver';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';

type BlogPageContentsProps = {
    setIsVisible?: (isVisible: boolean) => void;
};

function BlogPageContents({ setIsVisible }: BlogPageContentsProps) {
    const { activeId } = useScrollObserver('.blog-content__section h2');
    const [headings, setHeadings] = useState<
        Array<{ id: string; text: string }>
    >([]);

    useEffect(() => {
        setHeadings(
            Array.from(document.querySelectorAll('.blog-content__section h2'))
                .map((elem: HTMLElement) => ({
                    id: elem.id,
                    text: elem.innerText,
                }))
                .filter((heading) => heading.id),
        );
    }, []);

    return (
        <>
            <div className="hidden cursor-pointer justify-start font-demi text-md lg:flex">
                <span>Table of contents</span>
            </div>
            <div
                className="flex items-center justify-center font-demi lg:hidden"
                onClick={() => setIsVisible && setIsVisible(false)}
            >
                <span className="mr-2">Table of contents</span>
                <FontAwesomeIcon icon={faChevronDown} />
            </div>
            <hr className="my-4 border-t border-t-grey-200" />
            <p className="lg:hidden">Select a section to jump to</p>
            <ul>
                {headings.map((heading) => (
                    <li
                        key={heading.text}
                        className="mt-2 rounded-lg bg-grey-100 font-demi hover:cursor-pointer hover:bg-green-dark hover:text-white"
                    >
                        <a
                            href={`#${heading.id}`}
                            onClick={(e) => {
                                e.preventDefault();

                                const headingId = document.querySelector(
                                    `#${heading.id}`,
                                );
                                if (headingId) {
                                    headingId.scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'start',
                                        inline: 'nearest',
                                    });
                                }
                                if (setIsVisible) {
                                    setIsVisible(false);
                                }
                            }}
                            className={classNames('block p-2', {
                                'rounded-lg bg-green-dark p-2 text-white':
                                    activeId === heading.id,
                            })}
                        >
                            {heading.text}
                        </a>
                    </li>
                ))}
            </ul>
        </>
    );
}

export default BlogPageContents;
